import { useState } from 'react';
import LayoutContext from './layout.context';
import RefreshContext from './refresh.context';

export default function Context({ children }) {
  const [stateManagerLayout, setStateManagerLayout] = useState(LayoutContext);
  const [refreshProps, setRefreshProps] = useState(RefreshContext);

  return (
    <RefreshContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{ refreshProps, setRefreshProps }}
    >
      <LayoutContext.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={[stateManagerLayout, setStateManagerLayout]}
      >
        {children}
      </LayoutContext.Provider>
    </RefreshContext.Provider>
  );
}
